import { useState, useEffect } from 'react';
import { getSearchParams } from '@helsenorge/core-utils/querystring-utils';
import { getHelsenorgeUrl, getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import { warn } from '@helsenorge/framework-utils/logger';
/**
 * URL som skal brukes som retururl i brødsmulestien. Både retururl og retururltekst må være definert.
 *
 * retururl kan være en absolutt URL, men må da være en URL til www.helsenorge.no eller tjenester.helsenorge.no.
 *
 * Dersom retururl er relativ, vil den bli prefikset med tjenester.helsenorge.no.
 */
export const RETURURL_PARAM = 'retururl';
/**
 * Tekst som skal brukes sammen med retururl i brødsmulestien. Både retururl og retururltekst må være definert.
 */
export const RETURURLTEKST_PARAM = 'retururltekst';
export const useReturUrl = () => {
    const [returUrl, setReturUrl] = useState();
    useEffect(() => {
        const rawHelsenorgeUrl = getHelsenorgeUrl();
        const rawTjenesterUrl = getTjenesterUrl();
        if (!rawHelsenorgeUrl || !rawTjenesterUrl) {
            // Dersom brødsmulestien brukes utenfor våre domener, vil vi ikke kunne finne riktig retururl
            return;
        }
        const helsenorgeUrl = new URL(rawHelsenorgeUrl);
        const tjenesterUrl = new URL(rawTjenesterUrl);
        const params = getSearchParams();
        const rawReturUrl = params.get(RETURURL_PARAM);
        const rawReturUrlTekst = params.get(RETURURLTEKST_PARAM);
        if (!rawReturUrl || !rawReturUrlTekst) {
            return;
        }
        // Støtter bare absolutte URLer til våre egne domener
        if (rawReturUrl.startsWith('http://') || rawReturUrl.startsWith('https://')) {
            try {
                const url = new URL(rawReturUrl);
                if (url.hostname === helsenorgeUrl.hostname || url.hostname === tjenesterUrl.hostname) {
                    setReturUrl({ returUrl: url.toString(), returUrlTekst: rawReturUrlTekst });
                }
            }
            catch (e) {
                warn(`Ikke en gyldig URL: ${rawReturUrl}`, e);
            }
        }
        else {
            try {
                const url = new URL(rawReturUrl, tjenesterUrl);
                setReturUrl({ returUrl: url.toString(), returUrlTekst: rawReturUrlTekst });
            }
            catch (e) {
                warn(`Ikke en gyldig URL: ${rawReturUrl}`, e);
            }
        }
    }, []);
    return returUrl;
};
